import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import React from "react";
import appUserRoutes from "../../../appUserRoutes";
import apiPlatform from "../../../apiPlatform";
import ClientLabel from "../../Client/ClientLabel";
import PriceFormatted from "../../Application/PriceFormatted";
import AppTable from "../../../componentsReusable/AppTable";
import workerHasPrivilege from "../../../utils/workerHasPrivilege";
import ObjectLinkWithDetails from "../../../componentsReusable/ObjectLinkWithDetails";
import moment from "moment/moment";
import WarehouseProductLabel from "../WarehouseProduct/WarehouseProductLabel";
import displayDependentOnShowPrice from "../../../utils/displayDependentOnShowPrice";

const WarehouseDocumentLabel = props => {
  const {t} = useTranslation('warehouse_document_label')
  const [warehouseDocumentData, setWarehouseDocumentData] = React.useState(null)

  const getDetailsBody = () => {

    return (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row flex-nowrap justify-content-between">
        <div className="d-flex flex-column text-truncate">
          {workerHasPrivilege('clients.view') && <ClientLabel client={warehouseDocumentData.client}/>}
          {warehouseDocumentData.date && <div className="d-flex flex-nowrap flex-column flex-sm-row align-items-sm-center">
          <span className="pr-2">{t('date')}:</span>
            {warehouseDocumentData.date && <span className="text-ellipsis">{moment(warehouseDocumentData.date).format('YYYY-MM-DD')}</span>}
          </div>}
          {warehouseDocumentData.externalDocumentNumber && <div className="d-flex flex-nowrap flex-column flex-sm-row align-items-sm-center">
          <span className="pr-2">{t('external_number')}:</span>
            {warehouseDocumentData.externalDocumentNumber && <span className="text-ellipsis">{warehouseDocumentData.externalDocumentNumber}</span>}
          </div>}
        </div>
        <div>
          <div className="d-flex flex-nowrap text-nowrap">
            <div className="d-flex flex-column text-right">
              <span className="text-secondary text-uppercase">{displayDependentOnShowPrice(t('total_net'), t('total_gross'))}:</span>
            </div>
            <div className="d-flex flex-column text-right">
              <span className="ml-2"><PriceFormatted value={displayDependentOnShowPrice(warehouseDocumentData.totalNet, warehouseDocumentData.totalGross)}/></span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        {warehouseDocumentData.items && <div className="mt-2">
        <AppTable
            tableSize={'sm'}
            pagination={false}
            searchable={false}
            disableMinHeightTable
            maxHeight={'35vh'}
            columns={[
              {
                dataField: 'name',
                text: t('items_table_name'),
                formatter: (cell, row) => {
                  if(row?.warehouseProduct?.product?.id){
                    return <WarehouseProductLabel productId={row.warehouseProduct.product.id} name={cell} />
                  }

                  return cell;
                },
              },
              {
                dataField: 'total',
                text: t('table_value'),
                headerStyle: {
                  width: 115
                },
                align: 'right',
                headerAlign: 'right',
                footerAlign: 'right',
                formatter: (cell, row) => <PriceFormatted value={displayDependentOnShowPrice(row.totalNet, row.totalGross)} />,
              },
            ]}
            data={warehouseDocumentData.items}
          />
        </div>}
      </div>
    </div>);
  }

  return <ObjectLinkWithDetails
    icon={props.icon}
    className={props.className}
    link={appUserRoutes.warehouseDocument.view(props.warehouseDocumentId)}
    linkText={props.linkText ? props.number : null}
    disableRedirect={props.disableRedirect}
    disableDetails={!workerHasPrivilege('warehouses.globalPreview')}
    objectData={warehouseDocumentData ? {
      title: props.number,
      body: () => getDetailsBody(),
    } : null}
    getObjectData={() => apiPlatform.warehouseDocuments.get(props.warehouseDocumentId).then(({data}) => setWarehouseDocumentData(data))}
  />
}
WarehouseDocumentLabel.defaultProps = {
  icon: "fas fa-files-o",
  disableRedirect: false,
  linkText: true,
};

WarehouseDocumentLabel.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  linkText: PropTypes.bool,
  warehouseDocumentId: PropTypes.number.isRequired,
  number: PropTypes.string.isRequired,
  disableRedirect: PropTypes.bool
};

export default WarehouseDocumentLabel;